export default __webpack_public_path__ + "static/media/discussion1page1.e0c89d6e.jpg";